import { lazy } from "react";
import { PATHS } from "@/lib/router";

const SettingsPage = lazy(() => import("./pages/SettingsPage"));

export const settingsRoutes = [
  {
    path: PATHS.SETTINGS,
    element: <SettingsPage />,
    handle: {
      permission: { resource: "user_profile", action: "view" },
      defaultView: true,
    },
  },
];
